// Angular Files
import { Injectable, isDevMode } from '@angular/core';

// Component Files
import {
    LOCAL_RUM_CONFIG,
    RumPortal,
    TellerOnlineRumConfig,
    readRumConfig
} from './rum.models';
import { TellerOnlineRumEngagementService } from './rum-engagement.service';
import { TellerOnlineRumNavigationService } from './rum-navigation.service';
import { TellerOnlineRumService } from './rum.service';

// Service Files
import { TellerOnlineSiteMetadataService } from '../services/site-metadata.service';

/** Wires RUM up once the site metadata has loaded; both portals call start() at bootstrap. */
@Injectable({ providedIn: 'root' })
export class TellerOnlineRumBootstrapService {
    constructor(
        private siteMetadataService: TellerOnlineSiteMetadataService,
        private rumService: TellerOnlineRumService,
        private navigationService: TellerOnlineRumNavigationService,
        private engagementService: TellerOnlineRumEngagementService
    ) { }

    public start(portal: RumPortal): void {
        try {
            const config = this._resolveConfig();
            this.rumService.init(config, {
                tenant: this.siteMetadataService.tenant ?? 'default',
                portal
            });
            this.navigationService.start();
            this.engagementService.start();
        } catch (err) {
            // Telemetry must never break bootstrap
            console.warn('RUM bootstrap failed', err);
        }
    }

    /** The rum section of the site metadata; the DTO mapping lives here and nowhere else. */
    private _resolveConfig(): TellerOnlineRumConfig | undefined {
        const config = readRumConfig(this.siteMetadataService.appConfiguration?.rum);
        const real = config?.enabled && config.environment !== 'local' && !!config.appMonitorId;

        // A development build with nothing real configured still shows events in the console
        return real || !isDevMode() ? config : LOCAL_RUM_CONFIG;
    }
}
